<div class="image-slider-with-descriptions">
  <swiper-container
    [attr.slides-per-view]="slidesPerView()"
    (swiperinit)="onSwiper($event)"
    center-insufficient-slides="true"
    >
    @for (item of items | async; track item) {
      <swiper-slide>
        <a
          class="image-slide"
          [href]="item.link"
          target="_parent"
          [attr.aria-label]="item.title"
          >
          <div class="img" [ngStyle]="getImgStyle(item.imageUrl)"></div>
          <div class="text">
            <span
              class="title"
              [ngClass]="{ 'small-text': item.title.length > 64 }"
              >
              {{ item.title }}
            </span>
            @if (item.description) {
              <span
                class="description"
                [innerHTML]="item.description"
                >
              </span>
            }
            <span class="call-to-action">
              {{ getCallToAction(item.type) }} <i class="fas fa-arrow-right"></i>
            </span>
          </div>
        </a>
      </swiper-slide>
    }
  </swiper-container>

  @if (swiper?.activeIndex != 0) {
    <button
      (click)="navigateTo(swiper.activeIndex - 1)"
      class="prev-btn"
      >
      <app-slider-arrow-icon direction="left"></app-slider-arrow-icon>
    </button>
  }
  @if (!swiper?.isEnd) {
    <button
      (click)="navigateTo(swiper.activeIndex + 1)"
      class="next-btn"
      >
      <app-slider-arrow-icon direction="right"></app-slider-arrow-icon>
    </button>
  }
</div>
<div class="pagination">
  @for (x of items | async; track x; let i = $index) {
    @if (
      i >= swiper?.activeIndex + slidesPerView() || i <= swiper?.activeIndex
      ) {
      <div
        class="indicator"
        [ngClass]="{ on: i == swiper?.activeIndex }"
        (click)="navigateTo(i)"
      ></div>
    }
  }
</div>
